import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import _ from 'lodash'
import React from 'react'

import calidad from '../../../../../logo/calidad.png'
import plantilla from '../../../../../logo/plantilla_encabezado_reportes_laridae.png'
import { mapObjectsArrayToAllStringWithoutNulls } from '../../../../Utils/actions'
import { estilos } from './styles'

const styles = StyleSheet.create(estilos)

/* Funcion para Generar reportes en PDF

Props:
info, objeto que contiene
}
  titulo: 'Detalle de Mercaderia Fumigada',
  subtitulo: 'Entre fechas'
  version: 'Version de Laridae'
}
fields, arreglo de objetos
    {
      name: 'cartaDePorte',
      label: 'Carta de Porte',
      width: '70'
    }
data, arreglo de objetos
TODO: Ancho de columnas automatico
*/

const renderTitulo = ({ field, key }) => {
  return (
    <View key={key} style={[styles.tableCol, { width: field.width, fontWeight: 'bold', fontSize: '24px', backgroundColor: '#00305c' }]}>
      <Text style={styles.tableTituloCell}>{field.mantenerCase === undefined ? field.label : field.mantenerCase ? field.label : _.startCase(field.label)}</Text>
    </View>
  )
}

const renderTitulos = (fields = null) => {
  return (
    fields.map((field, index) => {
      return renderTitulo({ field, key: (index + Math.random()) })
    })
  )
}

const renderField = ({ field, value, key }) => {
  if (typeof (value) === 'string' || typeof (value) === 'number') {
    return (
      <View key={key} style={[styles.tableCol, { width: field.width }]}>
        <Text style={styles.tableCell}>{value}</Text>
      </View>
    )
  } else {
    return (
      <View key={key} style={[styles.tableCol, { width: field.width }]}>
        <Text style={styles.tableCell} />
      </View>
    )
  }
  // moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

const renderFields = (data, fields = null) => {
  return (
    fields
      .map((field, index) => {
        return renderField({ field, value: data[field.name], key: (index + Math.random()) })
      })
  )
}

const GenerarPdfOneTableOnly = (props) => {
  const info = props.info || {}
  const fields = props.fields || []
  const data = mapObjectsArrayToAllStringWithoutNulls(props.data)
  const pagesData = []
  data.forEach((d, i) => {
    const pageIndex = Math.floor(i / 5000)
    pagesData[pageIndex] ? pagesData[pageIndex].push(d) : pagesData[pageIndex] = [d]
  })
  const pages = pagesData.map(pageData => (
    <Page size='A4' orientation={props.orientacion} style={styles.page} key={Math.floor(Math.random())} wrap>
      <Image src={plantilla} style={styles.logo} />
      {info.titulo && <Text style={styles.title}>
        {info.titulo}
      </Text>}
      {info.descripcion && <Text style={styles.title}>
        {info.descripcion}
      </Text>
      }
      {info.subtitulo && <Text style={styles.subtitle}>
        {info.subtitulo}
      </Text>}
      <View style={styles.table}>
        <View style={styles.tableRow} wrap={false}>
          {renderTitulos(fields)}
        </View>
        {pageData
          ? pageData.map((data, key) => {
            let fondo = styles.tableRow.backgroundColor
            if (key % 2 === 0) { fondo = '#F2F2F2' }
            return (
              <View key={`${data.nroMuestra}-${Math.random()}`} style={[styles.tableRow, { backgroundColor: fondo }]} wrap={false}>
                {renderFields(data, fields)}
              </View>
            )
          }) : ''}
      </View>
      {info.total && <Text style={styles.total}>
        {info.total}
      </Text>}
      <Text
        style={styles.footer}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
      {info.version &&
      <Text
        style={styles.version}
        fixed
      >{info.version}
      </Text>}
      <Image
        src={calidad}
        style={styles.footerLogo}
        fixed />
    </Page>))
  return (
    <Document
      author='Terminal Quequén S.A.'
      subject='Reportes de Laridae 7'
      title={info.titulo || 'Reporte'}
    >
      {pages}
    </Document>
  )
}

export default GenerarPdfOneTableOnly
